const isAppName = (appName: string): boolean => {
  const app = process.env.REACT_APP_NAME
  return appName.toLowerCase() === app?.toLowerCase()
}

const getAppName = (): string => {
  const fromEnv = (process.env.REACT_APP_NAME ?? 'ge').toLowerCase()

  if (typeof window !== 'undefined' && window.location.hostname.includes('acai-brasil')) {
    return 'acai-brasil'
  }

  return fromEnv
}

const isTeaConnection = (): boolean => {
  return isAppName('tea')
}

export const ConfigUtils = {
  isAppName,
  isTeaConnection,
  getAppName,
}
